/**
 * Linkovi home sekcija unutar burger menija (mobilni / uski layout).
 */

import React from 'react';
import { useHomeSectionNav } from '../context/HomeSectionNavContext';

const HomeSectionNavBurgerLinks = ({ onNavigate }) => {
  const nav = useHomeSectionNav();

  if (!nav?.sections?.length) {
    return null;
  }

  return (
    <div
      className="burger-menu-section home-section-burger-links"
      role="group"
      aria-label="Секције почетне странице"
    >
      {nav.sections.map(({ id, label }) => {
        const isActive = nav.activeSectionId === id;
        return (
          <button
            key={id}
            type="button"
            className={`burger-menu-item burger-menu-item--section${
              isActive ? ' burger-menu-item--section-active' : ''
            }`}
            aria-current={isActive ? 'true' : undefined}
            onClick={() => {
              nav.scrollToSection(id);
              onNavigate?.();
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default HomeSectionNavBurgerLinks;
